export default __webpack_public_path__ + "static/media/explorelearning.fa8ae663.png";